import styled from 'styled-components';
import { BreakPoint } from '@makemydeal/dr-activities-common';
import { MAX_APP_CONTAINER_WIDTH_NEW } from '@makemydeal/dr-shared-ui-utils';

export const CompactHeaderActionsWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    align-content: center;
    flex-wrap: wrap;
    width: 100%;
    max-width: ${MAX_APP_CONTAINER_WIDTH_NEW};
    margin: 0 auto;
    overflow: hidden;
    border-top: ${({ theme }) => `1px solid ${theme.tokens.BaseColorGray300}`};
    margin-top: ${({ theme }) => `${theme.spacing(1)}`};
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    gap: ${({ theme }) => `${theme.spacing(1)}`};

    & .deal-dates-and-status-container {
        flex: 1 0 auto;
        @media only screen and (max-width: ${BreakPoint.SMALL}) {
            flex: unset;
        }
    }

    & .deal-status-container .dashboard-container {
        text-align: left;
    }

    & .actions-container {
        padding: 0px;
        gap: 0px;
        width: auto;
        margin: unset;

        & .deal-comments-baseFooter {
            bottom: unset;
            top: 145px;
        }

        & .ids-status-indicator-root {
            margin-right: 10px;
        }
    }
`;
